/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signuptitle1Inputs */

const en_signuptitle1 = /** @type {(inputs: Signuptitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-up`)
};

const de_signuptitle1 = /** @type {(inputs: Signuptitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldung`)
};

/**
* | output |
* | --- |
* | "Sign-up" |
*
* @param {Signuptitle1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signuptitle1 = /** @type {((inputs?: Signuptitle1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signuptitle1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signuptitle1(inputs)
	return de_signuptitle1(inputs)
});
export { signuptitle1 as "signupTitle" }